export default __webpack_public_path__ + "static/media/instagram-square-brands.f0b88b90.svg";